import { Link } from "#src/components/Router.tsx";
import tw from "#src/utils/tw.ts";

interface Props {
  className?: string;
  to: string;
  children: React.ReactNode;
}

const HeaderLogo = (props: Props) => (
  <Link
    to={props.to}
    className={tw(
      "block h-[50px] sm:flex-1 overflow-hidden truncate align-top leading-[50px] text-baseGray no-underline! hover:text-baseGray [&_img]:inline [&_img]:cursor-pointer",
      props.className
    )}
  >
    {props.children}
  </Link>
);

export default HeaderLogo;
